import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { movies } from '@/mocks/movies';
import { CATEGORY_LABELS } from '@/types/movie';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import FeaturedSection from './components/FeaturedSection';
import HotRanking from './components/HotRanking';

export default function Home() {
  useDocumentMeta({
    title: '妖精视频 - 全方位影视资源与精彩视频推荐',
    description:
      '妖精视频提供丰富的影视资源与精彩视频内容，包含最新电影、电视剧、综艺等多类别，满足用户观看和查询影视内容的需求。',
    keywords: '妖精视频,影视视频,电影资源,电视剧推荐,综艺节目,视频播放,影视资讯',
  });

  const movieList = movies.filter((m) => m.category === 'movie');
  const tvList = movies.filter((m) => m.category === 'tv');
  const varietyList = movies.filter((m) => m.category === 'variety');

  const featured = [...movies]
    .sort((a, b) => b.heat - a.heat)
    .slice(0, 5);

  const hotRanking = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 10);

  return (
    <SiteLayout>
      <h1 className="sr-only">妖精视频 - 全方位影视资源与精彩视频推荐</h1>

      <HeroCarousel items={featured} />

      <CategoryEntries />

      <FeaturedSection
        category="movie"
        title="精选电影"
        subtitle="最新上映与高口碑佳作，一网打尽"
        items={movieList.slice(0, 6)}
      />

      <FeaturedSection
        category="tv"
        title="热门电视剧"
        subtitle="正在热播与口碑领跑的高分剧集"
        items={tvList.slice(0, 6)}
      />

      <HotRanking items={hotRanking} />

      <FeaturedSection
        category="variety"
        title="人气综艺"
        subtitle="新季上线与人气话题节目合集"
        items={varietyList.slice(0, 6)}
      />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="rounded-lg bg-primary-900 px-6 md:px-12 py-10 md:py-14">
          <div className="max-w-3xl">
            <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-background-50">
              关于妖精视频
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-primary-100">
              妖精视频是一个面向广大影迷的综合影视内容展示与推荐平台。我们网罗最新电影、
              热门电视剧、精选综艺等多类别视频内容，通过清晰的分类、多维筛选与热度推荐，
              帮助每一位观众更快找到值得一看的作品。
            </p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
              <div>
                <div className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">5000+</div>
                <div className="mt-1 text-xs text-primary-200">收录影视作品</div>
              </div>
              <div>
                <div className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">
                  {Object.keys(CATEGORY_LABELS).length}
                </div>
                <div className="mt-1 text-xs text-primary-200">核心内容分类</div>
              </div>
              <div>
                <div className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">每日</div>
                <div className="mt-1 text-xs text-primary-200">更新推荐内容</div>
              </div>
              <div>
                <div className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">全站</div>
                <div className="mt-1 text-xs text-primary-200">多维筛选排序</div>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                了解更多
              </Link>
              <Link
                to="/search"
                className="whitespace-nowrap rounded-md border border-primary-200/50 bg-primary-800/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800/70"
              >
                搜索影视内容
              </Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}